import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

const AuthorCard = () => {
  return (
    <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 p-6 rounded-xl border border-border/50 bg-muted/20 my-10">
      <Avatar className="h-16 w-16 border-2 border-primary/20">
        <AvatarImage src="/profile-pic.png" alt="Aniket Kasale" />
        <AvatarFallback>AK</AvatarFallback>
      </Avatar>
      <div className="text-center sm:text-left">
        <h3 className="font-semibold text-lg">Aniket Kasale</h3>
        <p className="text-primary text-sm font-medium mb-2">Frontend Engineer</p>
        <p className="text-muted-foreground text-sm leading-relaxed max-w-md">
          Building scalable products and delightful user experiences. Exploring agentic workflows, RAG, and modern frontend architecture.
        </p>
      </div>
    </div>
  );
};

export default AuthorCard;
